import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, Printer, Loader2 } from "lucide-react";
import { api, API } from "@/lib/api";
import { ProposalDocument } from "@/components/ProposalDocument";
import { OnyxWordmark } from "@/components/site/Brand";

export default function SharedProposal() {
  const { shareId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/public/proposals/${shareId}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [shareId]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-onyx-metal">This proposal link is invalid or has expired.</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center text-onyx-metal"><Loader2 className="animate-spin mr-2" /> Loading…</div>;

  return (
    <div className="min-h-screen bg-onyx-charcoal py-10">
      <div className="max-w-[900px] mx-auto px-4 flex items-center justify-between mb-6 no-print">
        <OnyxWordmark dark />
        <div className="flex gap-3">
          <a href={`${API}/public/proposals/${shareId}/pdf`} data-testid="share-download-pdf" className="flex items-center gap-2 bg-white text-onyx-black px-5 py-2.5 text-[11px] tracking-[0.12em] uppercase hover:bg-onyx-wood transition-colors">
            <Download size={15} /> Download PDF
          </a>
          <button onClick={() => window.print()} data-testid="share-print" className="flex items-center gap-2 border border-white/30 text-white px-5 py-2.5 text-[11px] tracking-[0.12em] uppercase hover:bg-white/10 transition-colors">
            <Printer size={15} /> Print
          </button>
        </div>
      </div>
      <div className="shadow-2xl">
        <ProposalDocument proposal={data.proposal} settings={data.settings} />
      </div>
    </div>
  );
}
